import { render } from "./render.vue?vue&type=template&id=dbb46936"
import script from "./render.vue?vue&type=script&lang=js"
export * from "./render.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__